import React, { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import EditTextField from "../EditArticle/EditTextField";
import { Grid, IconButton, Typography } from "@material-ui/core";
import { useDialog } from "../Dialogs/DialogProvider";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "hidden",
  },
}));

const languageTranslations = {
  english: "en",
  dutch: "nl",
  german: "de",
  spanish: "se",
};

function TranslationForm(props) {
  const classes = useStyles();
  const [translationsObject, setTranslationsObject] = useState(props.translationsObject);
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogTitle id="simple-dialog-title">
        {props.intl.formatMessage({ id: "translate" })}
        {props.translationField && (
          <Typography variant="subtitle1" gutterBottom color={"primary"}>
            {props.translationField}
          </Typography>
        )}
        <IconButton onClick={() => closeDialog()} color="primary" style={{ position: "absolute", top: 8, right: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent
        classes={{
          root: classes.root, // class name, e.g. `classes-nesting-root-x`
        }}
      >
        <Grid container spacing={3}>
          {props.translationFields.map((field) => {
            const value = Object.keys(translationsObject).some((keys) => keys === field)
              ? translationsObject[field]
              : translationsObject[languageTranslations[field]];
            return (
              <Grid item xs={12} key={field + "-" + translationsObject[field]}>
                <EditTextField
                  key={new Date().toLocaleTimeString()}
                  value={value == null ? "" : value}
                  label={props.intl.formatMessage({ id: field })}
                  onBlur={(value, setBeginValue) => {
                    value = value === "" ? null : value;
                    props.updateTranslations(field, value).then(() => {
                      let newTranslationsObject = { ...translationsObject };
                      newTranslationsObject[field] = value;
                      setTranslationsObject(newTranslationsObject);
                      setBeginValue(value);
                    });
                  }}
                  variant={"standard"}
                />
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions></DialogActions>
    </>
  );
}

export default withIntl(TranslationForm);
